exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classes---logo---332FO {\n  height: 18rem; }\n", ""]);

// exports
exports.locals = {
	"logo": "classes---logo---332FO"
};